import taskpage from "./taskpage";

export default {taskpage}